/**
 * What a campaign is actually doing right now, from the operator's point of
 * view. `active` alone is misleading: a campaign whose end date has passed
 * keeps `active = true` but no rider sees it.
 */
export type CampaignServeStatus = 'live' | 'scheduled' | 'ended' | 'paused' | 'off';

export interface CampaignStatusInput {
  active: boolean;
  is_paused?: boolean | null;
  starts_at: string | null;
  ends_at: string | null;
}

export function campaignServeStatus(
  c: CampaignStatusInput,
  now: Date = new Date(),
): CampaignServeStatus {
  if (!c.active) return 'off';
  const t = now.getTime();
  if (c.ends_at && new Date(c.ends_at).getTime() <= t) return 'ended';
  if (c.is_paused) return 'paused';
  if (c.starts_at && new Date(c.starts_at).getTime() > t) return 'scheduled';
  return 'live';
}
